module.exports = __webpack_public_path__ + "static/media/lk.fffc2148.svg";